import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  top: -', 'px;\n  left: -', 'px;\n  height: ', 'px;\n  width: ', 'px;\n  min-height: ', 'px;\n  min-width: ', 'px;\n  display: block;\n  cursor: pointer;\n  input {\n    position: absolute;\n    opacity: 0;\n  }\n\n  & input:not(:checked) ~ .checkmark {\n    background-color: white;\n    border: 2px solid #d7d6de;\n  }\n\n  & input:checked ~ .checkmark,\n  &:hover input ~ .checkmark {\n    background-color: #48d8a9;\n    border: 2px solid #48d8a9;\n  }\n\n  & input:checked ~ .checkmark:after,\n  &:hover input ~ .checkmark:after {\n    opacity: 1;\n  }\n'], ['\n  position: relative;\n  top: -', 'px;\n  left: -', 'px;\n  height: ', 'px;\n  width: ', 'px;\n  min-height: ', 'px;\n  min-width: ', 'px;\n  display: block;\n  cursor: pointer;\n  input {\n    position: absolute;\n    opacity: 0;\n  }\n\n  & input:not(:checked) ~ .checkmark {\n    background-color: white;\n    border: 2px solid #d7d6de;\n  }\n\n  & input:checked ~ .checkmark,\n  &:hover input ~ .checkmark {\n    background-color: #48d8a9;\n    border: 2px solid #48d8a9;\n  }\n\n  & input:checked ~ .checkmark:after,\n  &:hover input ~ .checkmark:after {\n    opacity: 1;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  content: \'\';\n  position: absolute;\n  top: ', 'px;\n  left: ', 'px;\n  height: ', 'px;\n  width: ', 'px;\n  background-color: white;\n  border: 2px solid #d7d6de;\n  border-radius: ', 'px;\n  transition: all 0.2s;\n\n  &:after {\n    flex-shrink: 0;\n    content: \'\';\n    position: absolute;\n    opacity: 0;\n    transition: opacity 0.2s;\n    left: ', 'px;\n    top: ', 'px;\n    width: ', 'px;\n    height: ', 'px;\n    border: solid white;\n    border-width: 0 3px 3px 0;\n    -webkit-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n'], ['\n  content: \'\';\n  position: absolute;\n  top: ', 'px;\n  left: ', 'px;\n  height: ', 'px;\n  width: ', 'px;\n  background-color: white;\n  border: 2px solid #d7d6de;\n  border-radius: ', 'px;\n  transition: all 0.2s;\n\n  &:after {\n    flex-shrink: 0;\n    content: \'\';\n    position: absolute;\n    opacity: 0;\n    transition: opacity 0.2s;\n    left: ', 'px;\n    top: ', 'px;\n    width: ', 'px;\n    height: ', 'px;\n    border: solid white;\n    border-width: 0 3px 3px 0;\n    -webkit-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n']);

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { utils } from 'gipsy-misc';

var propTypes = {
  id: PropTypes.any,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  paramName: PropTypes.string.isRequired,
  label: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.number,
  checkmarkWidth: PropTypes.number.isRequired,
  checkmarkHeight: PropTypes.number.isRequired,
  checkmarkLeft: PropTypes.number.isRequired,
  checkmarkTop: PropTypes.number.isRequired,
  borderRadius: PropTypes.number,
  offsetTop: PropTypes.number,
  extraSpace: PropTypes.number /* extra clickable area around the checkbx */
};

var Checkbox = function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Checkbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
      if (_this.props.onChange) {
        _this.props.onChange({
          id: _this.props.id,
          paramName: _this.props.paramName,
          value: (1 + _this.props.checked) % 2
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Checkbox, [{
    key: 'shouldComponentUpdate',


    /*
     ** We use handmade shouldComponentUpdate instead of PureComponent in order to ignore the onChange function
     ** it allows us to create a new function on every render in the parent : onChange={() => { doSomething() }}
     ** without rerendering the component everytime the parent is rendered (PureComponent have this side effect )
     */
    value: function shouldComponentUpdate(nextProps, nextState) {
      var ignores = ['onChange'];
      for (var prop in propTypes) {
        if (ignores.indexOf(prop) !== -1) {
          continue;
        }
        if (this.props[prop] !== nextProps[prop]) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          id = _props.id,
          paramName = _props.paramName,
          onChange = _props.onChange,
          checked = _props.checked,
          size = _props.size,
          borderRadius = _props.borderRadius,
          extraSpace = _props.extraSpace,
          offsetTop = _props.offsetTop,
          checkmarkWidth = _props.checkmarkWidth,
          checkmarkHeight = _props.checkmarkHeight,
          checkmarkLeft = _props.checkmarkLeft,
          checkmarkTop = _props.checkmarkTop,
          props = _objectWithoutProperties(_props, ['className', 'id', 'paramName', 'onChange', 'checked', 'size', 'borderRadius', 'extraSpace', 'offsetTop', 'checkmarkWidth', 'checkmarkHeight', 'checkmarkLeft', 'checkmarkTop']);

      return React.createElement(
        Container,
        {
          size: size,
          extraSpace: extraSpace,
          offsetTop: offsetTop,
          className: 'gp-checkbox-container' + (className ? ' ' + className : ''),
          onClick: utils.DOM.stopPropagation },
        React.createElement('input', _extends({ type: 'checkbox', onChange: this.onChange, className: 'gp-checkbox', checked: checked }, props)),
        React.createElement(CheckMark, {
          size: size,
          borderRadius: borderRadius,
          extraSpace: extraSpace,
          width: checkmarkWidth,
          height: checkmarkHeight,
          left: checkmarkLeft,
          top: checkmarkTop,
          className: 'checkmark'
        })
      );
    }
  }]);

  return Checkbox;
}(Component);

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = {
  size: 24,
  extraSpace: 0,
  offsetTop: 2,
  checkmarkWidth: 4,
  checkmarkHeight: 8,
  checkmarkLeft: 7,
  checkmarkTop: 3,
  borderRadius: 10 };


export default Checkbox;

var Container = styled.label(_templateObject, function (props) {
  return props.extraSpace - props.offsetTop;
}, function (props) {
  return props.extraSpace;
}, function (_ref2) {
  var size = _ref2.size,
      extraSpace = _ref2.extraSpace;
  return size + extraSpace * 2;
}, function (_ref3) {
  var size = _ref3.size,
      extraSpace = _ref3.extraSpace;
  return size + extraSpace * 2;
}, function (_ref4) {
  var size = _ref4.size,
      extraSpace = _ref4.extraSpace;
  return size + extraSpace * 2;
}, function (_ref5) {
  var size = _ref5.size,
      extraSpace = _ref5.extraSpace;
  return size + extraSpace * 2;
});

var CheckMark = styled.span(_templateObject2, function (props) {
  return props.extraSpace;
}, function (props) {
  return props.extraSpace;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.left;
}, function (props) {
  return props.top;
}, function (props) {
  return props.width;
}, function (props) {
  return props.height;
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/Checkbox/index.js
// module id = 825
// module chunks = 0